import { atom } from 'jotai';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';

interface TenantContext {
  currentTenantId?: string;
  currentTenantName?: string;
}

const storage = createJSONStorage<TenantContext | null>(() => localStorage);

const tenantContextAtom = atomWithStorage<TenantContext | null>('tenant_context', null, storage, {
  getOnInit: true,
});

const updateTenantContextAtom = atom(
  null,
  (_get, set, params: { tenantId: string; tenantName: string }) => {
    set(tenantContextAtom, {
      currentTenantId: params.tenantId,
      currentTenantName: params.tenantName,
    });
  },
);

const switchTenantAtom = atom(
  null,
  (_get, set, params: { tenantId: string; tenantName: string }) => {
    set(tenantContextAtom, {
      currentTenantId: params.tenantId,
      currentTenantName: params.tenantName,
    });
  },
);

export { switchTenantAtom, tenantContextAtom, updateTenantContextAtom };
